// src/utils/numberToWords.ts
const UNIDADES = [
    'CERO', 'UN', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'
];
const DECENAS = [
    'DIEZ', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISÉIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE',
    'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'
];
const CENTENAS = [
    'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS',
    'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS'
];

export const numberToWords = (number: number): string => {
    const parts = number.toFixed(2).split('.');
    const integerPart = parseInt(parts[0]);
    const decimalPart = parseInt(parts[1]);

    if (integerPart === 0) return 'CERO PESOS';
    
    const convert = (n: number): string => {
        if (n === 0) return '';
        else if (n === 1) return 'UN';
        else if (n < 10) return UNIDADES[n];
        else if (n < 20) return DECENAS[n - 10];
        else if (n < 100) {
            const decena = Math.floor(n / 10);
            const unidad = n % 10;
            if (unidad === 0) return DECENAS[decena + 8];
            return DECENAS[decena + 8] + ' Y ' + UNIDADES[unidad];
        }
        else if (n < 1000) {
            const centena = Math.floor(n / 100);
            const resto = n % 100;
            if (resto === 0) {
                if (n === 100) return 'CIEN';
                return CENTENAS[centena - 1];
            }
            if (n === 100) return 'CIEN';
            return CENTENAS[centena - 1] + ' ' + convert(resto);
        }
        else if (n < 1000000) {
            const miles = Math.floor(n / 1000);
            const resto = n % 1000;
            if (resto === 0) return convert(miles) + ' MIL';
            if (miles === 1) return 'MIL ' + convert(resto);
            return convert(miles) + ' MIL ' + convert(resto);
        }
        else if (n < 1000000000) {
            const millones = Math.floor(n / 1000000);
            const resto = n % 1000000;
            if (resto === 0) {
                if (millones === 1) return 'UN MILLÓN';
                return convert(millones) + ' MILLONES';
            }
            if (millones === 1) return 'UN MILLÓN ' + convert(resto);
            return convert(millones) + ' MILLONES ' + convert(resto);
        }
        return 'NÚMERO FUERA DE RANGO';
    };

    let result = convert(integerPart) + ' PESOS';
    if (decimalPart > 0) {
        result += ' CON ' + decimalPart + '/100';
    }
    return result + ' (COP)';
};